import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    machines: {
        data: [],
        count: null,
        isLoading: false,
        isLoaded: false
    },
    machine: {
        data: null,
        isLoading: false,
        isLoaded: false
    },
    machineLogs: {
        data: null,
        isLoading: false,
        isLoaded: false,
    },
    machineDailySales:{
        data: [],
        month: null,
        year: null,
        isLoading: false,
        isLoaded: false
    },
    organizations: {
        data: [],
        isLoading: false,
        isLoaded: false
    },
    statusText: ""
};

export default createReducer(initialState,{
    [C.GET_MACHINES_REQUEST]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: true
        }
    }),
    [C.GET_MACHINES_FAILURE]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoaded: false,
            isLoading: false,
        }
    }),
    [C.GET_MACHINES_SUCCESS]: (state, payload) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: true,
            data: payload.machines,
            count: payload.count,
            pages: payload.pages,
            page: payload.page,
        }
    }),
    [C.CREATE_MACHINE]: (state, payload) => ({
        ...state,
        machines: {
            ...state.machines,
            data: [
                ...state.machines.data,
                payload
            ].sort((a, b) => (a.id > b.id ? 1 : -1)),
            count: state.machines.count + 1,
        },
    }),
    [C.CREATE_MACHINE_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка создания пользователя"
    }),
    [C.GET_MACHINE_REQUEST]: (state) => ({
        ...state,
        machine: {
            ...state.machine,
            isLoading: true,
        }
    }),
    [C.GET_MACHINE_FAILURE]: (state) => ({
        ...state,
        machine: {
            ...state.machine,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки информации об автомате."
    }),
    [C.GET_MACHINE_SUCCESS]: (state, payload) => ({
        ...state,
        machine: {
            ...state.machine,
            data: payload,
            isLoading: false,
            isLoaded: true,
        }
    }),
    [C.GET_MACHINE_DAILY_SALES_REQUEST]: (state) => ({
        ...state,
        machineDailySales:{
            ...state.machineDailySales,
            isLoading: true,
        }
    }),
    [C.GET_MACHINE_DAILY_SALES_FAILURE]: (state) => ({
        ...state,
        machineDailySales: {
            ...state.machineDailySales,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ощибка загрузки списка продаж автомата."
    }),
    [C.GET_MACHINE_DAILY_SALES_SUCCESS]: (state, payload) => ({
        ...state,
        machineDailySales: {
            ...state.machineDailySales,
            isLoading: false,
            isLoaded: true,
            data: payload.data,
            month: payload.month,
            year: payload.year,
        }
    }),
    [C.EDIT_MACHINE]: (state, payload) => ({
        ...state,
        machine: {
            ...state.machine,
            data: payload,
        }
    }),
    [C.EDIT_MACHINE_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка изменения настоек автомата"
    }),
    [C.DELETE_MACHINE]: (state, payload) => ({
        ...state,
        machines: {
            ...state.machines,
            data: state.machines.data !== [] ? state.machines.data.map(machine => (machine.id !== payload ? machine: null)).filter(n => n) : [],
            count: state.machines.count ? state.machines.count - 1 : null
        },
        machine: {
            ...state.machine,
            data: state.machine.data && state.machine.id !== payload ? null : state.machine.data,
            isLoaded: state.machine.data && state.machine.id !== payload ? false : state.machine.isLoaded,
        }
    }),
    [C.DELETE_MACHINE_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка удаления аппарата"
    }),
    [C.GET_MACHINES_ORGANIZATIONS_REQUEST]: (state) => ({
        ...state,
        organizations: {
            ...state.organizations,
            isLoading: true
        }
    }),
    [C.GET_MACHINES_ORGANIZATIONS_FAILURE]: (state) => ({
        ...state,
        organizations: {
            ...state.organizations,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки списка организаций."
    }),
    [C.GET_MACHINES_ORGANIZATIONS_SUCCESS]: (state, payload) => ({
        ...state,
        organizations: {
            ...state.organizations,
            isLoading: false,
            isLoaded: true,
            data: payload,
        }
    }),
    [C.GET_MACHINE_LOGS_REQUEST]: (state) => ({
        ...state,
        machineLogs: {
            ...state.machineLogs,
            isLoading: true
        },
    }),
    [C.GET_MACHINE_LOGS_FAILURE]: (state) => ({
        ...state,
        machineLogs: {
            ...state.machineLogs,
            isLoaded: false,
            isLoading: false,
        },
    }),
    [C.GET_MACHINE_LOGS_SUCCESS]: (state, payload) => ({
        ...state,
        machineLogs: {
            ...state.machineLogs,
            data: payload,
            isLoaded: true,
            isLoading: false,
        }
    }),
})


// WEBPACK FOOTER //
// ./src/reducers/machines.js